import { render, staticRenderFns } from "./OrdersByPO.vue?vue&type=template&id=2c9a194f&scoped=true&"
import script from "./OrdersByPO.vue?vue&type=script&lang=js&"
export * from "./OrdersByPO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9a194f",
  null
  
)

export default component.exports